var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoClass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "31px",
    viewBox: "0 0 33 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "73C4D4CE-614E-428A-BAAB-7976411125BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-135.000000, -1035.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "class",
    transform: "translate(139.000000, 1039.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "20.6397597 22.8876792 13.7697754 18.5068359 5.01220703 23.9321289 8.26977539 14.6469727 -9.84101689e-13 9.29150391 10.092041 9.29150391 13.7697754 5.32907052e-15 16.1491699 9.29150391 25.0109863 9.29150391 17.2373047 14.6469727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-72",
    fill: "#FFFFFF",
    points: "10.7182617 7.52880859 10.7182617 20.8891602 5.01220703 23.9321289 8.11499023 14.9042969 2.59594727 9.75952148 9.24937152 9.83971558"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClass);
export default __webpack_public_path__ + "static/media/ico_class.de47906b82f3aa3776d5b3ee76e5acec.svg";
export { ForwardRef as ReactComponent };